export default {
  countryZones(state) {
    return state.countryZones || []
  },

  inCountryZones(state) {
    return state.inCountryZones || []
  },

  zoneManagerPanelVisibility(state) {
    return state.isZoneManagerPanelOpen
  },

  activeCountryZone(state) {
    return state.activeCountryZone
  },

  activeInCountryZone(state) {
    return state.activeInCountryZone
  },
}
